<div class="loading" fxLayout="row" fxLayoutAlign="center">
  <mat-spinner mode="indeterminate" fxFlexAlign="center"></mat-spinner>
</div>
